// Unified currency format utility
export default function formatCurrency(amount, currency = 'MYR') {
  if (typeof amount !== 'number') amount = Number(amount) || 0;
  const formatted = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  switch (currency) {
    case 'MYR': return `${formatted} MYR`;
    case 'CNY': return `${formatted} CNY`;
    case 'HKD': return `${formatted} HKD`;
    case 'USD': return `${formatted} USD`;
    default: return `${formatted} ${currency}`;
  }
}
